module.exports = __webpack_public_path__ + "img/metro.fd7ed751.png";